import React, { useState } from 'react';
import { apiRequest } from '../services/api';
import { toast } from 'react-toastify';

const TourBooking = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        datetime: '',
        destination: '',
        persons: '',
        kids: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prev => ({ ...prev, [id]: value }));
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors[id];
            return newErrors;
        });
    };

    const validate = () => {
        let formIsValid = true;
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = 'Name is required';
            formIsValid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
            formIsValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
            formIsValid = false;
        }

        if (!formData.datetime.trim()) {
            newErrors.datetime = 'Date & Time is required';
            formIsValid = false;
        }

        if (!formData.destination.trim()) {
            newErrors.destination = 'Destination is required';
            formIsValid = false;
        }

        if (!formData.persons.trim()) {
            newErrors.persons = 'Persons is required';
            formIsValid = false;
        }

        if (!formData.kids.trim()) {
            newErrors.kids = 'Kids is required';
            formIsValid = false;
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        

        if (validate()) {
            setLoading(true);
            try {
                await apiRequest({
                    url: '/enquiry-form/send', // API route from Laravel
                    method: 'POST',
                    data: formData,
                });

                toast.success('Enquiry sent successfully!');
                setFormData({
                    name: '',
                    email: '',
                    datetime: '',
                    destination: '',
                    persons: '',
                    kids: '',
                    message: '',
                });
                setErrors({});
            } catch (error) {
                toast.error(error.message || 'Failed to send enquiry.');
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="container-fluid booking py-5">
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <h5 className="section-booking-title pe-3">Booking</h5>
                        <h1 className="text-white mb-4">Book Now</h1>

                    </div>
                    <div className="col-lg-6">
                        <h1 className="text-white mb-3">Book Your Tour Deals</h1>
                        <p className="text-white mb-4">
                            Get discounted deal on your first trip with Holiday Basket
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text"
                                            value={formData.name}
                                            onChange={handleChange}
                                            className="form-control bg-white border-0"
                                            id="name"
                                            placeholder="Your Name" />
                                        <label htmlFor="name">Your Name</label>
                                        {errors.name && <small className="text-danger">{errors.name}</small>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text" value={formData.email}
                                            onChange={handleChange} className="form-control bg-white border-0" id="email" placeholder="Your Email" />
                                        <label htmlFor="email">Your Email</label>
                                        {errors.email && <small className="text-danger">{errors.email}</small>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating date" id="date3" data-target-input="nearest">
                                        <input type="text" value={formData.datetime}
                                            onChange={handleChange} className="form-control bg-white border-0" id="datetime" placeholder="Date & Time" />
                                        <label htmlFor="datetime">Date of travel</label>
                                        {errors.datetime && <small className="text-danger">{errors.datetime}</small>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <div className="form-floating">
                                            <input type="text" value={formData.destination}
                                                onChange={handleChange} className="form-control bg-white border-0" id="destination" placeholder="Destination" />
                                            <label htmlFor="name">Destination</label>
                                            {errors.destination && <small className="text-danger">{errors.destination}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <div className="form-floating">
                                            <input type="text" value={formData.persons}
                                                onChange={handleChange} className="form-control bg-white border-0" id="persons" placeholder="Persons" />
                                            <label htmlFor="name">Adult</label>
                                            {errors.persons && <small className="text-danger">{errors.persons}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">

                                        <div className="form-floating">
                                            <div className="form-floating">
                                                <input type="text" value={formData.kids}
                                                    onChange={handleChange} className="form-control bg-white border-0" id="kids" placeholder="Kids" />
                                                <label htmlFor="name">Child</label>
                                                {errors.kids && <small className="text-danger">{errors.kids}</small>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea value={formData.message}
                                            onChange={handleChange} className="form-control bg-white border-0" placeholder="Special Request" id="message" style={{ height: '100px' }}></textarea>
                                        <label htmlFor="message">Special Request</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button className="btn btn-primary text-white w-100 py-3" disabled={loading} type="submit">
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Please wait...
                                            </>
                                        ) : (
                                            'Send'
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TourBooking;
